import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#141e12', color: '#d6d3d1', fontFamily: 'system-ui, sans-serif',
        }}>
          <div style={{ textAlign: 'center', maxWidth: 400, padding: 32 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>
              <span style={{ color: '#78716c' }}>Pro</span><span style={{ color: '#b45309' }}>Praxis</span>
            </div>
            <h2 style={{ fontSize: 18, marginBottom: 8, color: '#a8a29e' }}>Что-то пошло не так</h2>
            <p style={{ fontSize: 13, color: '#78716c', marginBottom: 24 }}>
              {this.state.error?.message || 'Произошла непредвиденная ошибка'}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#b45309', color: 'white', border: 'none', borderRadius: 8,
                padding: '10px 24px', fontSize: 14, cursor: 'pointer',
              }}
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
